// The scraped `event_type` vocabulary has 17 values with real overlaps
// (Buli/Party, Előadás/Színház/Stand up/Mozi, Gyerekprogram/Családi program).
// The UI shows nine clean categories; each one queries every raw type it covers.
// Shared verbatim with mobile/utils/eventCategories.js.

export const CATEGORIES = [
  { id: 'concert', icon: '♪', image: 'koncert', types: ['Koncert'] },
  { id: 'party', icon: '✦', image: 'party', types: ['Party', 'Buli'] },
  { id: 'festival', icon: '★', image: 'fesztival', types: ['Fesztivál'] },
  { id: 'stage', icon: '▲', image: 'eloadas', types: ['Előadás', 'Színház', 'Stand up', 'Mozi'] },
  { id: 'family', icon: '♥', image: 'csalad', types: ['Családi program', 'Gyerekprogram'] },
  { id: 'exhibition', icon: '◈', image: 'kiallitas', types: ['Kiállítás', 'Expo'] },
  { id: 'dance', icon: '✧', image: 'tanc', types: ['Tánc'] },
  { id: 'learning', icon: '◉', image: 'ismeretterjesztes', types: ['Ismeretterjesztés', 'Program'] },
  { id: 'sport', icon: '⬢', image: 'sport', types: ['Sport', 'Jóga'] }
];

const FALLBACK_CATEGORY = {
  id: 'other',
  icon: '◆',
  image: 'egyeb',
  types: []
};

function normalize(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

const TYPE_TO_CATEGORY = new Map();
for (const category of CATEGORIES) {
  for (const type of category.types) {
    TYPE_TO_CATEGORY.set(normalize(type), category);
  }
}

export function getCategoryForType(eventType) {
  return TYPE_TO_CATEGORY.get(normalize(eventType)) || FALLBACK_CATEGORY;
}

export function getCategoryById(id) {
  return CATEGORIES.find((category) => category.id === id) || FALLBACK_CATEGORY;
}

// Raw event_type values to send to the API for the given category ids.
export function categoriesToEventTypes(categoryIds = []) {
  const types = [];
  for (const id of categoryIds) {
    types.push(...getCategoryById(id).types);
  }
  return types;
}

// Only offer categories that actually have upcoming events, and carry the count
// through so chips can show it. `options` is the API's [{ value, count }] list.
export function buildCategoryOptions(eventTypeOptions = []) {
  const counts = new Map();

  for (const option of eventTypeOptions) {
    const category = getCategoryForType(option.value);
    counts.set(category.id, (counts.get(category.id) || 0) + (option.count || 0));
  }

  return CATEGORIES
    .filter((category) => counts.has(category.id))
    .map((category) => ({ ...category, count: counts.get(category.id) }));
}
